// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ExtEnrollmentInsuranceVerificationModel {
    static getAttributeTypeMap() {
        return ExtEnrollmentInsuranceVerificationModel.attributeTypeMap;
    }
}
ExtEnrollmentInsuranceVerificationModel.discriminator = undefined;
ExtEnrollmentInsuranceVerificationModel.additionalProperties = false;
ExtEnrollmentInsuranceVerificationModel.attributeTypeMap = [
    {
        "name": "insuranceType",
        "baseName": "insuranceType",
        "type": "TCSInsuranceType"
    },
    {
        "name": "payerName",
        "baseName": "payerName",
        "type": "string"
    },
    {
        "name": "payerPhone",
        "baseName": "payerPhone",
        "type": "string"
    },
    {
        "name": "bin",
        "baseName": "bin",
        "type": "string"
    },
    {
        "name": "pcn",
        "baseName": "pcn",
        "type": "string"
    },
    {
        "name": "payerMedicalId",
        "baseName": "payerMedicalId",
        "type": "string"
    },
];
//# sourceMappingURL=extEnrollmentInsuranceVerificationModel.js.map